import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import type { IKeyValueTableData } from "@/components_v3/types/goals";
import BaseSelect from "@/components-UI/BaseSelect.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'KeyValueTable',
  props: {
    isEdit: Boolean,
    tableData: {
        required : true,
        type: Object as () => IKeyValueTableData,
    },
    selectsData: {
        required: false,
        type: Array,
        default: Array as () => any[],
    },
},
  emits: ['update:items'],
  setup(__props, { emit: emits }) {

const props = __props



const tableItems = ref( props.tableData.items );


const onChangeSelect = ( bodyItemIdx, newValue ) => {
    tableItems.value[bodyItemIdx].value = newValue;
    emits('update:items', tableItems);
};

const onChangeInput = ( bodyItemIdx, item, flag ) => {
    if( Array.isArray( tableItems.value[bodyItemIdx].value ) ){
        tableItems.value[bodyItemIdx].value[0] = item;
    }else{
        tableItems.value[bodyItemIdx].value = item;
    }
    emits('update:items', flag ? { tableItems, flag } : tableItems );
};

return { __sfc: true,props, tableItems, emits, onChangeSelect, onChangeInput, BaseSelect }
}

})